<template>
  <div class="card">
    <div class="card-content">
      <div class="columns">
        <div class="column is-3">
          <b-select
           v-if="activeSelectStablishment"
            placeholder="Seleccionar Establecimiento"
            expanded
            :loading="loadingStablishment"
            v-model="stablishment_id"
            @change.native="changeListCat"
          >
            <option
              :value="stablishment.id"
              v-for="(stablishment, index) in listStablishment"
              :key="index"
            >
              {{ stablishment.name }}
            </option>
          </b-select>
        </div>
        <div class="column is-3">
          <b-select
            placeholder="Seleccionar Categorización"
            expanded
            :loading="loadingCat"
            v-model="categorization_id"
            @change.native="changeListSubCat"
          >
            <option
              :value="cat.id"
              v-for="(cat, index) in listCat"
              :key="index"
            >
              {{ cat.name }}
            </option>
          </b-select>
        </div>
        <div class="column is-5">
          <b-select
            placeholder="Seleccionar Subcategorización"
            expanded
            :loading="loadingSubCat"
            v-model="subCategorization_id"
          >
            <option
              :value="subcat.id"
              v-for="(subcat, index) in listSubCat"
              :key="index"
            >
              {{ subcat.name }}
            </option>
          </b-select>
        </div>
        <div class="column is-2">
          <b-button type="is-primary" @click="filterTable" icon-left="search" :disabled="!subCategorization_id">Buscar</b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { eventBus } from "../../main";
import { SubCategorizationFindByCategorizationId } from "../../services/subCategorization";
import { CategorizationFindByStablishmentId } from "../../services/categorization";
import { GetAllStablishment } from '../../services/stablishment';
export default {  
  props:['activeSelectStablishment'],
  data() {
    return {
      loadingCat: false,
      loadingSubCat: false,
      loadingStablishment: false,

      listStablishment:[],
      listSubCat: [],
      listCat: [],

      stablishment_id:null,
      categorization_id: null,
      subCategorization_id: null,
    };
  },
  mounted() {
    this.chargeData();
  },
  methods: {
    async chargeData() {
      this.loadingStablishment = true;
      this.listStablishment = await GetAllStablishment(this.$http);
      if(!this.activeSelectStablishment){
        this.stablishment_id=localStorage.getItem('stablishment_id');
        this.changeListCat();
      }
      this.loadingStablishment = false;
    },
    async changeListCat(){
      this.loadingCat = true;
      this.listCat = await CategorizationFindByStablishmentId(this.$http, this.stablishment_id);
      this.categorization_id=this.listCat[0].id;            
      this.changeListSubCat();    
      this.loadingCat = false;
    },   
    async changeListSubCat() {
      this.loadingSubCat = true;
      this.listSubCat = await SubCategorizationFindByCategorizationId(
        this.$http,
        this.categorization_id
      );
      this.subCategorization_id=this.listSubCat[0].id;
      this.loadingSubCat = false;
    },
    filterTable(){
      eventBus.$emit("loadBedList");
    }
  },
};
</script>